import type { ReactNode } from 'react';

import { HelpTip } from './HelpTip';

interface SectionCardProps {
  title: string;
  icon?: ReactNode;
  help?: ReactNode;
  children: ReactNode;
  className?: string;
  headerExtra?: ReactNode;
}

export function SectionCard({
  title,
  icon,
  help,
  children,
  className = '',
  headerExtra,
}: SectionCardProps) {
  return (
    <section
      className={`w-full min-w-0 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm ${className}`}
    >
      <header className="flex flex-wrap items-center justify-between gap-2 border-b border-gray-100 bg-gray-50/80 px-4 py-3">
        <div className="flex min-w-0 items-center gap-2">
          {icon ? <span className="text-stocker-primary shrink-0">{icon}</span> : null}
          <h2 className="text-sm font-semibold text-gray-900">{title}</h2>
          {help ? <HelpTip>{help}</HelpTip> : null}
        </div>
        {headerExtra ? <div className="flex items-center gap-2">{headerExtra}</div> : null}
      </header>
      <div className="p-4">{children}</div>
    </section>
  );
}
